import { render, staticRenderFns } from "./IresDeviceDetail.vue?vue&type=template&id=03584472&scoped=true&"
import script from "./IresDeviceDetail.vue?vue&type=script&lang=ts&"
export * from "./IresDeviceDetail.vue?vue&type=script&lang=ts&"
import style0 from "./IresDeviceDetail.vue?vue&type=style&index=0&id=03584472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03584472",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VHover,VIcon,VProgressCircular,VRow,VSnackbar,VSpacer})
